import { syncCartByCartId } from '@/api';
import {
  CART_LOADER,
  ON_CART_REFRESH_CONTENT_COMPLETED,
  WIDGET_MOUNT_ID,
} from '@/constants';
import { BigCommerceCart } from '@/types/bigcommerce';
import { log } from '@/utils';

import { getBigCommerceCart } from './bigcommerce';

// TODO: these should be refactored to newer event system that gets added to window object
export const attachCartEventListeners = () => {
  window.addEventListener(
    ON_CART_REFRESH_CONTENT_COMPLETED,
    handleSyncCartOnCartPage,
  );
};

export const onCartRefreshContentCompleted = () => {
  window.dispatchEvent(
    new CustomEvent(ON_CART_REFRESH_CONTENT_COMPLETED, {
      detail: {},
    }),
  );
};

export const beforeMountCartWidget = (callback: () => void) => {
  (async () => {
    const cart = await getBigCommerceCart();

    configureOfferingLineItems(cart);

    callback();
  })();
};

const configureOfferingLineItems = (cart: BigCommerceCart | null) => {
  if (cart && cart.lineItems?.customItems) {
    cart.lineItems?.customItems.map((item) => {
      const el = document.getElementById(`${WIDGET_MOUNT_ID}:${item.id}`);
      if (el) {
        // set applied offerings sku on widget mount component
        el?.setAttribute('data-sku', item.sku);

        // Disable applied offerings qty input and button
        const actions = el
          ?.closest('.cart-item')
          ?.querySelectorAll(
            '.form-increment button, .form-increment input, .form-increment select',
          );

        actions?.forEach((el) => ((el as HTMLButtonElement).disabled = true));
      }
    });
  }
};

export const handleSyncCartOnCartPage = async () => {
  log.info(ON_CART_REFRESH_CONTENT_COMPLETED);
  CART_LOADER.show();

  console.log(document.querySelector('[data-cart] .loadingOverlay'));

  if (await shouldRunSyncCart()) {
    const data = await syncCartByCartId();

    if (data && data.needs_refresh) {
      console.log(
        'inner',
        document.querySelector('[data-cart] .loadingOverlay'),
      );
      window.location.reload();
      return;
    }

    beforeMountCartWidget(() => {
      window.itsServices.mountCartWidget();
      CART_LOADER.hide();
    });
  } else {
    beforeMountCartWidget(() => {
      window.itsServices.mountCartWidget();
      CART_LOADER.hide();
    });
  }
};

export async function shouldRunSyncCart() {
  const cart = await getBigCommerceCart();

  if (!cart || !cart.lineItems) {
    return false;
  }

  const { physicalItems, digitalItems, customItems } = cart.lineItems;

  const baseItemQuantities = new Map();
  const allBaseItems = [...physicalItems, ...digitalItems];

  allBaseItems.forEach((item) => {
    const currentQty = baseItemQuantities.get(item.sku) || 0;
    baseItemQuantities.set(item.sku, currentQty + item.quantity);
  });

  const needsBalanced = (customItems || []).some((customItem) => {
    const customSku = customItem.sku;
    const parts = customSku.split(';');
    const baseSku = parts[parts.length - 1];

    const expectedQuantity = baseItemQuantities.get(baseSku);

    // This condition returns TRUE if the item doesn't have a matching parent item or quantity is wrong:
    return (
      expectedQuantity === undefined || customItem.quantity !== expectedQuantity
    );
  });

  return needsBalanced;
}
